import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@99designs/common/components/Avatar';
import { Mobile } from '@99designs/common/components/Mobile';
import { Desktop } from '@99designs/common/components/Desktop';
import { DesignerLevel, imageSources } from 'apps/find-designers/propTypes';
import DesignerBranding from 'apps/find-designers/components/Listing/DesignerBranding';
import DesignerActions from 'apps/find-designers/components/Listing/DesignerActions';
import ExperienceList from 'components/Designers/ExperienceList';
import DesignerRating from './DesignerRating';
import DesignGallery from './DesignGallery';

class DesignerListItem extends Component {
    designerRating() {
        return (
            <div className="designer-list-item__details__item">
                <DesignerRating
                    reviewUrl={this.props.urls.reviewUrl}
                    review={this.props.designer.review}
                />
            </div>
        );
    }

    render() {
        return (
            <div className="designer-list-item">
                <a
                    href={
                        this.props.urls.profileUrl // eslint-disable-line jsx-a11y/anchor-has-content
                    }
                    className="designer-list-item__link-overlay"
                />
                <div className="designer-list-item__avatar">
                    <Mobile>
                        <Avatar
                            user={{
                                avatarUrl: this.props.designer.avatarSrc,
                                profileUrl: this.props.urls.profileUrl,
                            }}
                            variations={['extra-small']}
                            isOnline={this.props.designer.isOnline}
                        />
                    </Mobile>
                    <Desktop>
                        <Avatar
                            user={{
                                avatarUrl: this.props.designer.avatarSrc,
                                profileUrl: this.props.urls.profileUrl,
                            }}
                            variations={['medium']}
                            isOnline={this.props.designer.isOnline}
                        />
                    </Desktop>
                </div>
                <div className="designer-list-item__details">
                    <span className="designer-list-item__details__inner">
                        <div className="designer-list-item__details__item">
                            <DesignerBranding
                                designer={this.props.designer}
                                profileUrl={this.props.urls.profileUrl}
                                isContact={this.props.designer.isContact}
                                workRelationshipDescriptions={
                                    this.props.designer.workRelationshipDescriptions
                                }
                            />
                        </div>
                        <div className="designer-list-item__details__item">
                            <DesignerActions
                                urls={this.props.urls}
                                isFavorite={this.props.designer.isFavorite}
                                canFavorite={this.props.designer.canFavorite}
                                designerId={this.props.designer.id}
                            />
                        </div>
                        {this.designerRating()}
                        <div className="designer-list-item__details__item">
                            <ExperienceList
                                expertiseCategories={this.props.designer.expertiseCategories}
                            />
                        </div>
                    </span>
                </div>
                <div className="designer-list-item__designs">
                    <DesignGallery designs={this.props.designs} />
                </div>
            </div>
        );
    }
}

DesignerListItem.propTypes = {
    designer: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        level: DesignerLevel.isRequired,
        canFavorite: PropTypes.bool.isRequired,
        isFavorite: PropTypes.bool,
        isContact: PropTypes.bool.isRequired,
        workRelationshipDescriptions: PropTypes.array.isRequired,
        review: PropTypes.shape({
            rating: PropTypes.number,
            count: PropTypes.number,
        }).isRequired,
        avatarSrc: PropTypes.string.isRequired,
        isOnline: PropTypes.bool.isRequired,
        expertiseCategories: PropTypes.array.isRequired,
    }).isRequired,
    designs: PropTypes.arrayOf(
        PropTypes.shape({
            designUrl: PropTypes.string,
            id: PropTypes.number,
            imageSources,
            title: PropTypes.string,
            description: PropTypes.string,
        })
    ).isRequired,
    urls: PropTypes.shape({
        inviteUrl: PropTypes.string.isRequired,
        favoriteUrl: PropTypes.string,
        reviewUrl: PropTypes.string.isRequired,
        profileUrl: PropTypes.string.isRequired,
    }).isRequired,
};

export default DesignerListItem;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignerListItem.jsx